export enum EntitySyncStatus {
    PENDING = "Pending",
    SYNC = "Sync",
    ANALYZING = "Analyzing",
    SUCCESS = "Success",
    FAILED = "Failed",
    NO_DATA_AVAILABLE = "No Data Available"
}